import { Grid } from '@mui/material';
import { makeStyles } from '@mui/styles';
import { TransactionTypeChar } from '@tassat/common-definitions';
import { TransactionHistoryRecord } from '@tassat/fred-extended-definitions';
import React from 'react';

interface AdminFirmWalletCellRendererProps {
    data: TransactionHistoryRecord;
    direction: 'sender' | 'receiver';
}

const muiStyles = makeStyles({
    firmName: {
        fontSize: '.9rem',
        lineHeight: '1.2rem'
    },
    walletName: {
        fontSize: '.75rem',
        lineHeight: '.9rem'
    }
});

const AdminFirmWalletCellRenderer = (props: AdminFirmWalletCellRendererProps) => {
    const {
        data,
        direction
    } = props;
    const classes = muiStyles(props);

    let mappedData = {
        firm: '',
        accountName: ''
    };

    if (direction === 'sender') {
        if (data.type !== TransactionTypeChar.deposit) {
            if (data.type === TransactionTypeChar.withdrawal) {
                mappedData = {
                    firm: data.RecipientFirm,
                    accountName: data.RecipientAccountName
                };
            } else {
                mappedData = {
                    firm: data.SenderFirm,
                    accountName: data.SenderAccountName
                };
            }
        }
    } else {
        if (data.type === TransactionTypeChar.deposit) {
            mappedData = {
                firm: data.SenderFirm,
                accountName: data.SenderAccountName
            };
        } else if (
            data.type !== TransactionTypeChar.order &&
            data.type !== TransactionTypeChar.withdrawal
        ) {
            mappedData = {
                firm: data.RecipientFirm,
                accountName: data.RecipientAccountName
            };
        }
    }

    return (
        <Grid
            container
            direction='column'
            justifyContent='center'
            spacing={0}
        >
            <span className={classes.firmName}>{mappedData.firm}</span>
            <span className={classes.walletName}>{mappedData.accountName}</span>
        </Grid>
    );
};

export default AdminFirmWalletCellRenderer;